import React from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'
import usePortalTarget from 'hooks/usePortalTarget'

interface PageTitleRightActionsProps {
  children: any
}

export const PAGE_TITLE_RIGHT_ACTIONS_ID = 'PAGE_TITLE_RIGHT_ACTIONS_ID'

export const PageTitleRightActions: React.FunctionComponent<PageTitleRightActionsProps> = ({
  children,
}) => {
  const target = usePortalTarget(PAGE_TITLE_RIGHT_ACTIONS_ID, 'span')

  return createPortal(children, target)
}

PageTitleRightActions.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.string,
    PropTypes.node,
  ]),
}
